module.exports = __webpack_public_path__ + "3490e487caa19f18e12df428378ebf50.png";